import React from 'react';
import { IonCard, IonContent, IonItem, IonLabel, IonList, IonPage, RefresherEventDetail, withIonLifeCycle } from '@ionic/react';
import { Link } from 'react-router-dom';

//	L O C A L I Z A T I O N

import { locale___App } from '../../App.locale';

//	S T Y L E

import './sb-dashboard.scss';

//	T Y P E S

import { type___api___response } from '../../types/types.api-response';

//	P R O P S

import { props___SbDashboardPage, state___SbDashboardPage, state___SbDashboardPage___default } from './sb-dashboard.state';

//	S E R V I C E S

import { service_LocalizationService } from '../../services/service-localization';
import { service_RestApiService } from '../../services/service-api';

//	C O M P O N E N T S

import ComDigitalMenuComponent from '../../components/com-digitalmenu/com-digitalmenu';
import ComSpinnerInlineComponent from '../../components/com-spinner-inline/com-spinner-inline';
import ComCopyrightComponent from '../../components/com-copyright/com-copyright';
import ComListSeparatorComponent from '../../components/com-list-separator/com-list-separator';

//	E X P O R T

class SbDashboardPage extends React.Component<props___SbDashboardPage, state___SbDashboardPage> {

//#region 																							D E C L A R A T I O N S

	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();
	private readonly _API: service_RestApiService = new service_RestApiService();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___SbDashboardPage,
	) {
		super(props);
		this.state = state___SbDashboardPage___default;
	}

//#endregion


//#region 																							R E A D   P R O P S

	private read_props___digitalmenu___collection = async () => {
		const ___temp___selected_event_props: type___api___response = await this._API.digitalmenus___read_multi(this.state.digitalmenu___collection.length);
		this.setState({
			digitalmenu___collection: ___temp___selected_event_props.data,
			digitalmenu___collection___isLoading: false
		});
	}

//#endregion

//#region 																							H A N D L E R S

	private handle___page___refresh = (___e: CustomEvent<RefresherEventDetail> | null = null) => {
		this.setState({
			digitalmenu___collection: [],
			digitalmenu___collection___isLoading: true,
		}, async () => {
			await this.read_props___digitalmenu___collection();
			if (___e) { ___e.detail.complete(); }
		});
	}

//#endregion

//#region 																							L I F E C Y C L E

	ionViewDidEnter() : void {
		this.setState({
			digitalmenu___collection: [],
			digitalmenu___collection___isLoading: true,
		}, async () => {
			await this.read_props___digitalmenu___collection();
		});
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return <>
			<IonPage>

				<IonContent forceOverscroll={ false }>
					<div className="sb-dashboard-page---container">

						<div className="sb-dashboard-page---img-header">
							<img src="/assets/logo.svg"/>
						</div>

						<br />
						<br />
						<br />

						{(this.state.digitalmenu___collection___isLoading === true) ? <>
							<ComSpinnerInlineComponent />
						</> : <>
							{this.state.digitalmenu___collection.map((___d: any, ___d___idx: number) => { return <>
								<Link to={ '/digitalmenu/view/' + ___d['digitalmenu_id'] }>
									<IonCard key={ ___d___idx }>
										<ComDigitalMenuComponent digitalmenu_props={ ___d }/>
									</IonCard>
								</Link>
								<ComListSeparatorComponent />
							</>;})}
						</>}

						<br />
						<br />

						<IonCard>
							<IonList>
								<IonItem className="is-ion-item-button" routerLink="/settings" routerDirection="forward">
									<i className="fa-solid fa-cog"></i>
									<IonLabel>Impostazioni</IonLabel>
								</IonItem>
							</IonList>
						</IonCard>

						<br />
						<br />
						<br />
						<br />
						<br />
						<br />

						<ComCopyrightComponent />

					</div>

				</IonContent>
			</IonPage>
		</>
	}

//#endregion

}

//	E X P O R T

export default withIonLifeCycle(SbDashboardPage);